// Mount the Live module: hand `createLiveModule` a lazy host (`./live-host`, which holds the app
// imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes and
// the catalog scopes from HERE, so the module cannot be mounted unregistered. This file must stay
// light: it is in the entry chunk. The HTTP client is not a member: the module reads it from the
// shared registry (`@vnetwork/margarita-core/http`).
import { createLiveModule } from '@vnetwork/margarita-live';

export const live = createLiveModule(() => import('./live-host').then((m) => m.liveHost));
